import { DialogHeader, DialogActions, DialogButton } from '~/components/ui/Dialog';

interface ConfirmLogoutDialogContentProps {
  onClose: VoidFunction;
}

export const ConfirmLogoutDialogContent = ({ onClose }: ConfirmLogoutDialogContentProps) => {
  return (
    <>
      <DialogHeader title="Logout" description="Are you sure you want to sign out?" />

      <DialogActions>
        <DialogButton variant="secondary" onClick={onClose}>
          Cancel
        </DialogButton>
        <DialogButton variant="primary" asChild>
          <a href="/logout">Sign Out</a>
        </DialogButton>
      </DialogActions>
    </>
  );
};
